<template>
    <table-ish>
        <table-ish-row-header>
            <table-ish-cell>
                Name
            </table-ish-cell>

            <table-ish-cell
                :shrink="true"
                class="text-right"
            >
                Status
            </table-ish-cell>
        </table-ish-row-header>
        <component
            :is="$gate.role('landlord') ? 'table-ish-row-router-link' : 'table-ish-row'"
            v-for="applicant in applicants"
            :key="applicant.uuid"
            :to="{
                name: $router.fix('dashboard.*.applications.applicants.show'),
                params: {
                    applicant: applicant.uuid
                }
            }"
        >
            <table-ish-cell>
                {{ applicant.name }}

                <template slot="secondary">
                    <template v-if="applicant.is_co_applicant">
                        Co-Applicant
                    </template>
                    <template v-else>
                        Primary Applicant
                    </template>
                </template>
            </table-ish-cell>

            <table-ish-cell
                :shrink="true"
                class="text-right"
            >
                <span
                    :class="activeStateCss(!!applicant.submitted_at)"
                    class="text-sm font-semibold rounded-full px-3 py-1"
                >
                    {{ applicant.submitted_at ? 'Completed' : 'Pending' }}
                </span>
            </table-ish-cell>
        </component>
    </table-ish>
</template>

<script>
    import StateCssMixin from '../mixins/state-css'

    export default {
        mixins: [
            StateCssMixin
        ],
        props: {
            applicants: {
                type: Array,
                required: true
            }
        }
    }
</script>
